import { DecimalFormatterService } from "./../../shared/models/decimal-formatter.service";
import { TranslateService } from "./../../shared/translate/translate.service";
import { AuthService } from "./../../shared/models/auth.service";
import { FlatPickrModel } from "./../../plugins/flatpickr/flatpickr.model";
import {
  Component,
  OnInit,
  OnChanges,
  Input,
  ViewChild,
  AfterViewInit
} from "@angular/core";
import { Router } from "@angular/router";
import { IKeyValueInterface, ApplicationRouteURL } from "./../../shared/config";

import { WeGoConfig, IAPIResponse, DataListModel } from "../../shared/config";
import { CostAndExpenseModel } from "../models/cost-expense.model";
import { CostAndExpenseService } from "../models/cost-expense.service";

const moment = require("moment");
const SlimSelect = require("slim-select");

@Component({
  selector: "wego-cost-expense-list",
  template: require('../views/cost-expense-list.component.html'),
  providers: [CostAndExpenseService],
  styles: [
    `
      .nopad-left {
        padding-left: 0px;
      }
      .form-horizontal .control-label {
        text-align: left;
      }
    `
  ]
})
export class CostAndExpenseListComponent implements OnInit {
  urlInvoice: String;
  urlPersonInfo: string;
  popupModel: CostAndExpenseModel;
  isMultipleDelete: boolean;
  deletecostAndExpenseHashId: string;
  LblStatus: string;
  LblSelect: string;
  itemPerPageList: number[];
  CostStatus: { Key: string; Value: string }[];
  public dateFormat: string = WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
  apiErrorMsg: string;
  DataListModel: DataListModel = new DataListModel();
  errorModel: IKeyValueInterface[];
  readMore: IKeyValueInterface[];
  costAndExpenseList: CostAndExpenseModel[];
  isLoading: boolean;
  isParentCheck: boolean;
  popupMessage: string;
  remarks: string;
  flatPickrConfigFrom: FlatPickrModel;
  flatPickrConfigTo: FlatPickrModel;
  model: CostAndExpenseModel;
  isParentCheckEnable: boolean;
  urlDefaultPage: string;
  popupMsg: string;
  private module: string;
  StatusSelect: any;

  @ViewChild("alertModal") public alertModal: any;
  @ViewChild("successPopup") public successPopup: any;
  @ViewChild("costAndExpensePopup") public costAndExpensePopup: any;
  @ViewChild("manualInvoiceLineUpdate") public manualInvoiceLineUpdate: any;

  get isAnyChecked(): boolean {
    if (this.costAndExpenseList) {
      let isCheck = this.costAndExpenseList.some(x => x.isChecked == true);
      if (isCheck) {
        if (
          this.costAndExpenseList
            .filter(y => y.isDeletable)
            .every(x => x.isChecked == true)
        )
          this.isParentCheck = true;
        else this.isParentCheck = false;
      } else {
        this.isParentCheck = false;
      }

      return isCheck;
    } else {
      this.isParentCheck = false;
      return false;
    }
  }

  constructor(
    private authService: AuthService,
    private router: Router,
    private translate: TranslateService,
    private costAndExpenseService: CostAndExpenseService
  ) {}

  ngOnInit() {
    this.module = this.translate.instant("LblCostAndExpenses");
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    this.DataListModel.searchField = [
      "ReportedByName",
      "Description",
      "CostType",
      "Status",
      "InvoiceNumber"
    ];

    this.model = new CostAndExpenseModel();
    this.popupModel = new CostAndExpenseModel();

    this.model.fromDateTime = moment()
      .add(-1, "M")
      .format("DD-MM-YYYY 00:00");
    this.model.toDateTime = moment()      
      .format("DD-MM-YYYY 23:59");

    this.LblStatus = this.translate.instant("LblStatus");
    this.LblSelect = this.translate.instant("LblSelect");

    this.CostStatus = [
      {
        Key: "PENDING",
        Value: "PENDING"
      },
      {
        Key: "APPROVED",
        Value: "APPROVED"
      },
      {
        Key: "REJECTED",
        Value: "REJECTED"
      }
    ];

    this.model.statusList = this.CostStatus.map(x => x.Value);

    this.model = this.authService.AssignFromStorage(
      this.constructor.name + "_model",
      this.model
    );

    this.urlInvoice = this.authService.GetURL(
      ApplicationRouteURL.URL_INVOICE_UPDATE
    );

    this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
    this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();
    this.urlDefaultPage = this.authService.GetURL(
      ApplicationRouteURL.URL_DEFAULT_PAGE
    );

    this.urlPersonInfo = this.authService.GetURL(
      ApplicationRouteURL.URL_PERSON_UPDATE
    );

    this.model.reportedByName = this.model.reportedByNameList.join();
    this.itemPerPageList = WeGoConfig.GRID_PAGGING;
    this.DataListModel.itemsPerPage = 10;
    this.GetCostAndExpenseList();
  }

  private SetDefaultFlatPickrConfig() {
    let flatPickrConfig = new FlatPickrModel();
    flatPickrConfig.enableTime = true;
    flatPickrConfig.time_24hr = true;
    flatPickrConfig.dateFormat = this.dateFormat;
    flatPickrConfig.minuteIncrement = 1;
    return flatPickrConfig;
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetCostAndExpenseList();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(
      this.DataListModel,
      event.searchTerm,
      event.isReset
    );
    if (event.isReset) {
      this.model.toDateTime = moment()
        .add(+1, "days")
        .format("DD-MM-YYYY 00:00");
      this.model.fromDateTime = moment()
        .add(-1, "M")
        .format("DD-MM-YYYY 00:00");
    }
    this.GetCostAndExpenseList();
  }
  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetCostAndExpenseList();
  }

  public OnExport(event: any) {
    this.isLoading = true;
    this.costAndExpenseService
      .ExportCostAndExpenseList(this.model, this.DataListModel)
      .subscribe(
        (res: any) => {
          if (res && res._body) {
            let fileName = "CostAndExpense" + new Date().toISOString() + ".csv";
            this.authService.DownloadFile(fileName, res._body);
          }
          this.isLoading = false;
        },
        (error: any) => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  private GetCostAndExpenseList() {
    this.isLoading = true;

    this.costAndExpenseService
      .GetCostAndExpenseList(this.model, this.DataListModel)
      .subscribe(
        res => {
          if (res.data) {
            this.costAndExpenseList = res.data;
            this.DataListModel.totalItems = res.totalRecords;
            this.DataListModel.infoMessage = res.error;
            this.isParentCheckEnable =
              this.costAndExpenseList.filter(x => x.isDeletable).length > 0
                ? true
                : false;
            this.isLoading = false;
            this.errorModel = null;
          } else {
            this.DataListModel.totalItems = res.totalRecords;
            this.DataListModel.infoMessage = this.translate.instant(
              "LblNoRecords"
            );
            this.errorModel = res.error;
            this.isLoading = false;
          }
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetCostAndExpenseList();
  }

  public OnParentCheck(isChecked: boolean) {
    this.costAndExpenseList
      .filter(y => y.isDeletable)
      .forEach(x => (x.isChecked = isChecked));
  }

  ngOnDestroy() {
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
    this.authService.SaveToStorage(
      this.constructor.name + "_model",
      this.model
    );
  }

  public StatusChangeMultiSelect() {}
  public SuccessSelectDriverModal($event: any) {
    this.model.reportedByNameList = $event.PersonName;
    this.model.reportedByName = this.model.reportedByNameList.join(",");
    this.model.reportedByPersonHashIdList = $event.PersonHashID;
  }

  public ClearReportedBy() {
    this.model.reportedByPersonHashId = "";
    this.model.reportedByNameList = [];
    this.model.reportedByName = "";
    this.model.reportedByPersonHashIdList = [];
  }

  ngAfterViewInit() {
    this.StatusSelect = new SlimSelect({
      select: "#status",
      placeholder: this.LblSelect + " " + this.LblStatus,
      showSearch: false,
      onChange: (info: any) => {
        this.model.statusList = info.map((x: any) => x.value);
      }
    });

    this.StatusSelect.set(this.model.statusList);
  }

  get isDeleteAccess(): boolean {
    if (this.costAndExpenseList) {
      return this.costAndExpenseList.some(x => x.isDeletable);
    } else {
      return false;
    }
  }

  public DeleteCostAndExpense(deleteCostAndExpenseHashId: string[]) {
    this.isLoading = true;
    this.costAndExpenseService
      .DeleteCostAndExpenses(deleteCostAndExpenseHashId)
      .subscribe(
        res => {
          this.DataListModel.currentPage = 1;
          this.GetCostAndExpenseList();
          this.popupMsg = this.translate.instant("LblRecordRemovedSuccess", [
            this.module
          ]);
          this.ShowSuccessPopup();
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public ShowAlertModal(costAndExpenseHashId?: string): void {
    if (costAndExpenseHashId) {
      this.popupMsg = this.translate.instant("LblRecordDeleteConfirmation", [
        this.module
      ]);
      this.isMultipleDelete = false;
      this.deletecostAndExpenseHashId = costAndExpenseHashId;
    } else {
      this.popupMsg = this.translate.instant(
        "LblRecordMultiplDeleteConfirmation",
        [this.module]
      );
      this.isMultipleDelete = true;
    }
    this.alertModal.show();
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
  }

  public HideAlertModal(): void {
    this.deletecostAndExpenseHashId = "";
    this.alertModal.hide();
  }

  public SuccessAlertModalClick(): void {
    let deleteCostAndExpenseList: any[];
    if (this.isMultipleDelete)
      deleteCostAndExpenseList = this.costAndExpenseList
        .filter(x => x.isChecked)
        .map(x => x.costAndExpenseHashId);
    else deleteCostAndExpenseList.push(this.deletecostAndExpenseHashId);

    this.DeleteCostAndExpense(deleteCostAndExpenseList);
    this.alertModal.hide();
  }

  public ShowCostAndExpensemodel(costAndExpenseviewModel: CostAndExpenseModel) {
    this.costAndExpenseService
      .GetCostAndExpenseByHashId(costAndExpenseviewModel.costAndExpenseHashId)
      .subscribe(
        res => {
          res.data.module = "COSTANDEXPENSELIST";
          if (res.data.reportedByDriver) {
            this.costAndExpensePopup.show(res.data);
          } else {
            console.log(costAndExpenseviewModel);

            this.manualInvoiceLineUpdate.model = res.data;

            if (costAndExpenseviewModel.invoiceStatus == "CLOSED") {
              this.manualInvoiceLineUpdate.model.isEditable = false;
            }
            this.manualInvoiceLineUpdate.show(
              this.manualInvoiceLineUpdate.model.isEditable
            );
          }
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public SuccessCostAndExpenseList() {
    this.popupMsg = this.translate.instant("LblRecordSavedSuccess", [
      this.module
    ]);
    this.GetCostAndExpenseList();
    this.ShowSuccessPopup();
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/cost-expenses/components/cost-expenses-list.components.ts